import React, {useRef, useState} from 'react';
import {Card, CardBody} from "../../../../_metronic/_partials/controls";
import {errorMessage, formatDate, formatMigrationStatus, formatUsername, permissionCssClass} from "../../../util/Helpers";
import {Button} from "react-bootstrap";
import SVG from "react-inlinesvg";
import {toAbsoluteUrl} from "../../../../_metronic/_helpers";
import ResetMigrationModal from "./modal/ResetMigrationModal";
import InitializeMigrationModal from "./modal/InitializeMigrationModal";
import MigrationDetails from "./modal/MigrationDetails";
import cogoToast from "cogo-toast";
import {useSelector} from "react-redux";
import {PermissionType, Permissions} from "../../../util/Permissions";
import DynamicSimpleTable from '../../../util/DynamicSimpleReactTable';

function Migrations() {
    const adminUser = useSelector(state => state.auth.user);
    const tableRef = useRef();

    /* Exchange Rate Modal State Management */
    const [migrationModal, setMigrationModal] = useState({
        showInitializeMigrationModal: false,
        showMigrationDetailsModal: false,
        showResetMigrationModal: false,
        details: null
    });

    /* Modal show/hide Toggle */
    const toggleModal = modal => _ => {
        setMigrationModal({...migrationModal, [modal]: !migrationModal[modal]})
    }

    /* View Migration Details Modal */
    const viewUserMigrationDetails = details => {
        setMigrationModal({...migrationModal, showMigrationDetailsModal: true, details});
    }

    /* Initialize Migration Modal*/
    const migrateUser = details => {
        setMigrationModal({
            ...migrationModal,
            showInitializeMigrationModal: true,
            details
        })
    }

    /* Reset Migration Modal */
    const resetUserMigration = details => {
        setMigrationModal({...migrationModal, showResetMigrationModal: true, details});
    }

    /* Action Buttons */
    const migrationAction = (row) => {
        return (
            <span style={{whiteSpace: "nowrap"}}>
                <Button
                    title="View Details"
                    className={`btn btn-icon btn-light btn-hover-primary btn-sm bg-white ${permissionCssClass(adminUser, Permissions.MIGRATIONS, PermissionType.READ)}`}
                    onClick={_ => viewUserMigrationDetails(row)}
                >
                    <span className="svg-icon svg-icon-md svg-icon-primary">
                        <SVG
                            title="View Details"
                            src={toAbsoluteUrl(
                                "/media/svg/icons/General/Eye-2.svg"
                            )}
                        />
                    </span>
                </Button>

                <Button
                    disabled={row?.user?.migrated === 1}
                    title="Start Migration"
                    className={`btn btn-icon btn-light btn-hover-primary btn-sm ml-3 ${permissionCssClass(adminUser, Permissions.MIGRATIONS, PermissionType.UPDATE)}`}
                    onClick={_ => migrateUser(row)}
                >
                    <span
                        className={`svg-icon svg-icon-md svg-icon-${row?.user?.migrated === 1 ? "muted" : "primary"}`}>
                        <SVG
                            title="Start Migration"
                            src={toAbsoluteUrl(
                                "/media/svg/icons/Media/Play.svg"
                            )}
                        />
                    </span>
                </Button>

                <Button
                    disabled={row?.user?.migrated === 1}
                    title="Reset Migration"
                    className={`btn btn-icon btn-light btn-hover-primary btn-sm ml-3 ${permissionCssClass(adminUser, Permissions.MIGRATIONS, PermissionType.UPDATE)}`}
                    onClick={_ => resetUserMigration(row)}
                >
                    <span
                        className={`svg-icon svg-icon-md svg-icon-${row?.user?.migrated === 1 ? "muted" : "primary"}`}>
                      <SVG
                          title="Reset Migration"
                          src={toAbsoluteUrl("/media/svg/icons/Code/Error-circle.svg")}
                      />
                    </span>
                </Button>
            </span>
        );
    };

    return (
        <div className="py-4 px-6">
            <Card>
                <CardBody>
                    <DynamicSimpleTable
                        source={{url: `/users/migration/migrated`}}
                        columns={[
                            {title: "USER", format: row => formatUsername(row.unique_id, row.username, row.email)},
                            {title: "PHONE", key: "phone"},
                            {title: "STATUS", format: (row) => formatMigrationStatus(row.user.migrated)},
                            {title: "UPDATED ON", format: (row) => formatDate(row.updatedAt)},
                            {title: "", format: migrationAction},
                        ]}
                        ref={tableRef}
                        onError={err => cogoToast.error(errorMessage(err))}
                        refreshIcon={true}
                    />
                </CardBody>
            </Card>

            {
                migrationModal.showMigrationDetailsModal &&
                    <MigrationDetails
                        showMigrationDetailsModal={migrationModal.showMigrationDetailsModal}
                        onHide={toggleModal("showMigrationDetailsModal")}
                        migrationStatus={migrationModal.details}
                    />
            }

            {
                migrationModal.showResetMigrationModal &&
                    <ResetMigrationModal
                        showResetMigrationModal={migrationModal.showResetMigrationModal}
                        onHide={toggleModal("showResetMigrationModal")}
                        details={migrationModal.details}
                        tableRef={tableRef}
                    />
            }

            {
                migrationModal.showInitializeMigrationModal &&
                    <InitializeMigrationModal
                        showInitializeMigrationModal={migrationModal.showInitializeMigrationModal}
                        onHide={toggleModal("showInitializeMigrationModal")}
                        details={migrationModal.details}
                        tableRef={tableRef}
                    />
            }

        </div>
    );
}

export default Migrations;